<template>
  <div v-if="review">
    <!-- Collapse Button for Entire Card -->
    <button class="btn btn-link text-primary font-weight-bold w-100 text-left border" type="button"
      data-toggle="collapse" data-target="#reviewCardCollapse" aria-expanded="true" aria-controls="reviewCardCollapse">
      {{ __('Show Review') }}
    </button>

    <!-- Collapsible Review Card -->
    <div class="collapse row guestflip-review" id="reviewCardCollapse">
      <!-- Review Section -->
      <div class="review-section d-flex flex-column">
        <div class="profile d-flex align-items-center">
          <div class="left">{{ review.guest.name[0] }}</div>
          <div class="right d-flex flex-column">
            <p class="name">
              <span>{{ review.guest.name }}</span>
            </p>
            <div>
              <div class="star-rating">
                <div class="stars-active">
                  <div class="stars" :style="'width:' + (review.average_rating / this.outOf) * 100 + '%;'
                    ">
                    <i class="fa fa-star" v-for="n in this.outOf" :key="'active-' + n"></i>
                  </div>
                </div>
                <div class="stars-inactive">
                  <i class="fa fa-star" v-for="n in this.outOf" :key="'inactive-' + n"></i>
                </div>
                <div class="rating-number">
                  {{ review.average_rating }}/{{ this.outOf }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Review Details -->
        <table class="review-details mt-3">
          <tbody>
            <tr>
              <th scope="row">{{ __('Source') }}</th>
              <td class="source">
                <img :src="'/assets/img/reviews/' + review.source + '.png'" alt="Source Logo" />
              </td>
            </tr>
            <tr>
              <th scope="row">{{ __('Date') }}</th>
              <td>{{ review.published_date }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Comment Section -->
      <div class="comment-section p-2">
        <div v-if="comments.length > 0">
          <h5 class="header-case">{{ __('User review') }}</h5>
          <h6 v-if="review.title" class="font-weight-bold">{{ review.title }}</h6>
          <div v-for="comment in comments" :key="comment.id" class="comment-container" :class="'kind-' + comment.kind">
            <p>{{ comment.comment }}</p>
          </div>
        </div>

        <p v-else>
          <em>{{ __("This guest didn't leave a review comment.") }}</em>
        </p>

        <!-- Collapsible Manager Response -->
        <button v-if="managerResponse" class="btn btn-link text-primary font-weight-bold float-right" type="button"
          data-toggle="collapse" data-target="#managerResponseCollapse" aria-expanded="false"
          aria-controls="managerResponseCollapse">
          {{ __('Show response') }}
        </button>

        <div class="collapse w-100 mt-5 pt-1 mb-3" id="managerResponseCollapse" ref="managerCollapse">
          <h5 class="header-case">{{ __('Your response') }}</h5>
          <div class="manager-response">
            <p v-if="managerResponse">{{ managerResponse.comment }}</p>
            <p v-else class="text-muted">No response from the manager yet.</p>
          </div>
        </div>

        <!-- Collapsible Note -->
        <button v-if="review.note" class="btn btn-link text-primary font-weight-bold"
          :class="{ 'float-left': !showResponse, 'float-right': showResponse }" type="button" data-toggle="collapse"
          data-target="#noteCollapse" aria-expanded="false" aria-controls="noteCollapse">
          {{ __('Show note') }}
        </button>

        <div class="collapse w-100 mt-5 pt-1" id="noteCollapse" ref="noteCollapse">
          <h5 class="header-case">{{ __('Your note') }}</h5>
          <div class="manager-response">
            <h6 v-if="review.title" class="font-weight-bold">{{ review.title }}</h6>
            <p v-if="review.note">{{ review.note }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewCard',
  props: {
    review: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showResponse: false,
      showNote: false,
    };
  },

  mounted() {
    $(this.$refs.managerCollapse).on('show.bs.collapse', () => {
      this.showResponse = true;
    });

    $(this.$refs.noteCollapse).on('show.bs.collapse', () => {
      this.showNote = true;
    });

    $(this.$refs.managerCollapse).on('hide.bs.collapse', () => {
      this.showResponse = false;
    });

    $(this.$refs.noteCollapse).on('hide.bs.collapse', () => {
      this.showNote = false;
    });
  },

  computed: {
    managerResponse() {
      // Find the first comment with kind = "manager"
      return this.review.comments.find((comment) => comment.kind === 'manager') || null;
    },

    comments() {
      // Filter out the manager response
      return this.review.comments.filter((comment) => comment.kind !== 'manager');
    },
    outOf() {
			return this.getRatingType(this.review.source);
		},
  },
};
</script>

<style scoped>
.guestflip-review {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 1rem;
  margin: 1rem 0;
}

.review-contextual-menu .dots img {
  width: 20px;
}

.comment-section {
  margin-top: 1rem;
}

.comment-container {
  margin-bottom: 1rem;
}

.manager-response {
  padding: 1rem;
  border: 1px solid #eee;
  background-color: #f9f9f9;
}
</style>
